/**
 * Frontend ordinal mirror of the backend {@code com.mvs.backend.lg.enums.MappingFallbackEnum}.
 *
 * `LogicMappingTable.fallbackBehaviour` is persisted with `@Enumerated(ORDINAL)`, so members are
 * positions and must only ever be appended.
 */
export enum MappingFallbackEnum {

    ERROR,
    NULL_VALUE,
    DEFAULT_VALUE,
    USE_LOGIC,
}

/** German UI label per fallback strategy. */
export const MappingFallbackLabel: Record<MappingFallbackEnum, string> = {
    [MappingFallbackEnum.ERROR]: 'Fehler auslösen',
    [MappingFallbackEnum.NULL_VALUE]: 'Kein Wert',
    [MappingFallbackEnum.DEFAULT_VALUE]: 'Standardwert der Tabelle',
    [MappingFallbackEnum.USE_LOGIC]: 'Fallback-Logik ausführen'
};

/**
 * Returns the German UI label for a fallback strategy.
 *
 * An ABSENT strategy is not 'nothing configured': `LogicMappingService.applyFallback` treats null
 * exactly like {@link MappingFallbackEnum.ERROR}, so the label says so instead of rendering a blank.
 * Showing an empty cell here would hide a table that throws on every miss.
 *
 * @param fallback the ordinal as it arrives from the backend, or null/undefined when unset
 */
export function getMappingFallbackLabel(fallback: MappingFallbackEnum | null | undefined): string {
    if (fallback === null || fallback === undefined) {
        return 'Nicht gesetzt (wirkt wie „Fehler auslösen“)';
    }
    return MappingFallbackLabel[fallback] ?? String(fallback);
}
